import { FC } from "react";
import { connectMenu } from "react-instantsearch-dom";
import { MenuProvided } from "react-instantsearch-core";
import { Trans } from "@lingui/macro";
import { DropdownOutlined } from "src/atoms/DropDown";
import PromotionFilter from "./PromotionFilter";
import { sortByAlphabet } from "src/organisms/AlgoliaProductList/utils/sortBy";

interface Props extends MenuProvided {
  filterIndex: number;
  outerRef: React.RefObject<HTMLDivElement>;
  setCurrentIndex: (index: number) => () => void;
  closeFilters: () => void;
  opened: boolean;
}

const ConnectMenu: FC<Props> = ({
  items,
  currentRefinement,
  refine,
  filterIndex,
  outerRef,
  setCurrentIndex,
  closeFilters,
  opened,
}) => {
  if (!items || !items.length) {
    return null;
  }

  return (
    <DropdownOutlined opened={opened}>
      <DropdownOutlined.Button onClick={setCurrentIndex(filterIndex)}>
        <span>
          <Trans>Promotions</Trans>
        </span>
      </DropdownOutlined.Button>
      <DropdownOutlined.Items>
        <PromotionFilter
          currentRefinement={currentRefinement}
          items={items.sort(
            sortByAlphabet as (
              a: { label: string },
              b: { label: string }
            ) => number
          )}
          refine={refine}
          outerRef={outerRef}
          onClose={closeFilters}
        />
      </DropdownOutlined.Items>
    </DropdownOutlined>
  );
};

const PromotionConnectMenu = connectMenu(ConnectMenu);

export default PromotionConnectMenu;
